import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IconType, IoniconsOutline } from '@pt/pt-models';

@Component({
  selector: 'pt-editor-sidebar-preview-btn',
  template: `
    <div class='position-relative'
         [ngClass]='{"cursor-not-allowed": disabled }'>
      <button class='btn btn-sm btn-link btn-preview'
              [disabled]='disabled'
              (click)='preview.emit()'>
          <span class='spinner-preview-container' *ngIf='loading'>
            <label role='status'
                   class='spinner-border spinner-border-sm spinner-preview'>
              <span class='visually-hidden'>Loading...</span>
            </label>
            <pt-icon class='spinner-preview-icon'
                     style="color: transparent"
                     [iconType]='IconType.IONIC_ICON'
                     [key]='IconPreview' [size]='10'
            ></pt-icon>
          </span>
        <pt-icon [iconType]='IconType.IONIC_ICON'
                 [key]='IconPreview'
                 [size]='14' *ngIf='!loading'>
        </pt-icon>
        <span>{{ 'LABELS.PREVIEW' | translate }}</span>
      </button>
    </div>
  `,
  styles: [`
    .btn-preview {
      font-size: 11px;
      display: flex;
      height: 25px;
      min-width: max-content;
      align-items: center;
      border: solid 1px currentColor;
    }

    .spinner-preview-container {
        position: relative;
        margin: 0 5px 2px 0;
    }

    .spinner-preview-container .spinner-preview {
      margin: 0;
      position: absolute;
    }

    .spinner-preview-container .spinner-preview-icon {
      margin-left: 1px;
    }
  `]
})
export class EditorSidebarPreviewBtnComponent {
  @Input() loading: boolean;
  @Input() disabled: boolean;
  @Output() preview = new EventEmitter();

  IconType = IconType;
  IconPreview = IoniconsOutline.doc;

}
